import { Component } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-demo-choice-dialog',
  standalone: true,
  imports: [MatDialogModule, MatIconModule, RouterModule],
  templateUrl: './demo-choice-dialog.component.html',
})
export class DemoChoiceDialogComponent {
  getStartedUrl() {
    return '/register';
  }
}
